import { render, staticRenderFns } from "./BillingImport.vue?vue&type=template&id=95f2c0aa&lang=html&"
import script from "./BillingImport.vue?vue&type=script&lang=js&"
export * from "./BillingImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports